import loaders from "@/assets/json-data/loaderData.js";

export default {
  state: {
    loader: {}
  },
  mutations: {
    setLoader(state, payload) {
      state.loader = payload;
    }
  },
  actions: {
    selectRandomLoader({ commit }) {
      let min = 0;
      let max = loaders.length - 1;
      let index = Math.floor(Math.random() * (max - min) + min);
      let loader = loaders[index];
      commit("setLoader", loader);
    }
  }
};
